import { DestroyRef, inject, provideAppInitializer } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { WindowRef } from '@boels/helpers';
import { CultureFacade } from '@boels/shared-state';

export const htmlLangProvider = provideAppInitializer(() => {
  const initializerFn = setHtmlLangAttribute(
    inject(WindowRef),
    inject(CultureFacade),
    inject(DestroyRef),
  );
  return initializerFn();
});

function setHtmlLangAttribute(
  winRef: WindowRef,
  cultureFacade: CultureFacade,
  destroyRef: DestroyRef,
): () => void {
  return () => {
    cultureFacade
      .getActiveCulture()
      .pipe(takeUntilDestroyed(destroyRef))
      .subscribe((culture: string) => {
        winRef.document.documentElement.lang = culture;
      });
  };
}
